module.exports = __webpack_public_path__ + "img/ASpace-putin.45e9bc1a.png";